import Swiper from 'swiper/bundle';
import 'swiper/css';

window.Swiper = Swiper;
jQuery(function ($) {
    const sm = 576;
    const md = 768;
    const lg = 992;
    const xl = 1200;

    //------------------------------------------------------
    // Functions
    //------------------------------------------------------

    const fetchSizeWatch = function () {
        const headerHeight = getComputedStyle(document.querySelector('header.header')).height;
        document.documentElement.style.setProperty('--header-height', headerHeight);
    }

    //------------------------------------------------------
    // Delegated events
    //------------------------------------------------------

    $(document).on('focus', '#searchform input[type="search"]', function (e) {
        $(this).addClass('focused');
        fetchSizeWatch();
    })

    $(document).on('blur', '#searchform input[type="search"]', function (e) {
        const input = $(this);
        setTimeout(function () {
            input.removeClass('focused');
            fetchSizeWatch();
        }, 500)
    })

    $(document).on('click', '#searchform input[type="search"]:not(.focused) + #searchsubmit', function (e) {
        e.preventDefault();
        $(this).siblings('input').addClass('focused').trigger('focus');
        fetchSizeWatch();
        return false;
    })

    $('[data-oninvalid]').each(function() {
        const input = $(this);

        input.on('input change', function (e) {
            this.setCustomValidity('');
        })
        input.on('invalid', function (e) {
            this.setCustomValidity($(this).attr('data-oninvalid'));
        })
    })

    // Permet le déplacement du label si le champs d'un input est rempli
    $(document).on('input', '.form-group input, .form-group textarea, .form-row input, .form-row textarea', function () {
        $(this).toggleClass('has-value', $(this).val().length > 0);
    })
    $('.form-group input, .form-group textarea, .form-row input, .form-row textarea').each(function () {
        $(this).toggleClass('has-value', $(this).val().length > 0);
    })

    //------------------------------------------------------
    // Modals
    //------------------------------------------------------

    $(document).on('click', '.modal .close', function (e) {
        closeModal($(this).closest('.modal'));
    });
    $(document).on('click', '.modal', function (e) {
        if ($(e.target).hasClass('modal'))
            closeModal(e.target);
    });
    window.showModal = function (name) {
        var target = null;
        if (typeof name === 'string' || name instanceof String) {
            target = $('.modal#modal-' + name);
            if (target.length === 0) {
                target = $(name);
            }
        } else {
            target = $(name);
        }

        if (target.length > 0 && target.hasClass('modal')) {
            $('.modal').removeClass('show');
            target.addClass('show');
            history.pushState('', document.title, window.location.pathname + window.location.search + '#' + name);
        }
    }
    window.closeModal = function (name) {
        var target = null;
        if (typeof name === 'string' || name instanceof String) {
            target = $('.modal#modal-' + name);
            if (target.length === 0) {
                target = $(name);
            }
        } else {
            target = $(name);
        }

        if (target.length > 0 && target.hasClass('modal')) {
            target.removeClass('show');
            history.pushState('', document.title, window.location.pathname + window.location.search);
        }
    }

    function toggleHashModals() {
        var hash = window.location.hash;
        if (hash) {
            $('.modal[data-hash-trigger="' + hash.substring(1) + '"]').addClass('show');
        }
    }

    toggleHashModals();
    $(window).on('hashchange', toggleHashModals);

    //------------------------------------------------------
    // Global events
    //------------------------------------------------------

    $(document).on('click', '[data-href]', function (e) {
        e.preventDefault();
        const target = $(this).data('target');
        if (target) {
            window.open($(this).data('href'), target);
        } else {
            window.location = $(this).data('href');
        }
    })
    $(window).on('load', function() {
        fetchSizeWatch();
    });
    window.addEventListener('resize', fetchSizeWatch);
    fetchSizeWatch();

    const optistickyinterval = setInterval(function() {
        const optisticky = $('.opd_adsticky');
        if(optisticky && optisticky.length > 0) {
            document.documentElement.style.setProperty('--optisticky-height', optisticky.height()+'px');
        } else {
            document.documentElement.style.setProperty('--optisticky-height', 0);
        }
    }, 1000);

    //------------------------------------------------------
    // Menu
    //------------------------------------------------------
    // Le menu (burger mobile + dépliage des sous-menus) fonctionne désormais
    // entièrement en CSS, sans JavaScript : voir la « checkbox hack » dans
    // partials/header/header.php, includes/misc/css-nav-walker.php et
    // assets/css/parts/_header.scss.



    //------------------------------------------------------
    // Article oembed
    //------------------------------------------------------


    const iframeObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            $(entry.target).find('.article-embed__wrapper').toggleClass('visible-not-in-viewport', !entry.isIntersecting);
        })
    })

    $(document).on('click', '.article-embed:not(.active)', function (e) {
        e.preventDefault();
        const wrapper = $(this);

        if($(this).hasClass('direct-link') || wrapper.width() <= 300) {
            window.location = wrapper.closest('[data-toosmall-href]').attr('data-toosmall-href');
            return;
        }

        if(!wrapper.find('.article-embed__wrapper').length) {
            // Disable other featured embed
            iframeObserver.disconnect()
            $('.article-embed .article-embed__wrapper').remove();
            $('.article-embed.active').removeClass('active');

            // Add new embed
            const template = wrapper.find('template');
            const iframe = $(template.get(0).content.cloneNode(true).querySelector('.article-embed__wrapper'));
            wrapper.append(iframe);
            wrapper.addClass('active');
            iframeObserver.observe(wrapper.get(0))
        }
    })

    $(document).on('click', '.article-embed__close', function (e) {
        e.preventDefault();
        iframeObserver.disconnect()
        $('.article-embed .article-embed__wrapper').remove();
        $('.article-embed.active').removeClass('active');
    })

    // On url hashtag change do something
    const hashtagObserver = function () {
        if (window.location.hash === '#cookies') {
            // Rewrite url to remove hashtag
            history.pushState('', document.title, window.location.pathname + window.location.search);
            // Call CMP UI
            window.Sddan.cmp.displayUI();
        }
    }
    $(window).on('hashchange', function() {
        hashtagObserver();
    })
    hashtagObserver();

});